import { render, staticRenderFns } from "./CustomCheckBox.vue?vue&type=template&id=1a5b110f&scoped=true"
import script from "./CustomCheckBox.vue?vue&type=script&lang=js"
export * from "./CustomCheckBox.vue?vue&type=script&lang=js"
import style0 from "./CustomCheckBox.vue?vue&type=style&index=0&id=1a5b110f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5b110f",
  null
  
)

export default component.exports